module.exports = __webpack_public_path__ + "img/btn_play.de71066b.svg";